import { RootState } from '../../types';

export const all = (state: RootState) => state.app.imageViewer;
export const isOpen = (state: RootState) => all(state).isOpen;
export const image = (state: RootState) => all(state).image;
